import SecondServer from '../database/SecondServer';
import {nestedPropertyOrNull} from './object.js';
import {tokenToJson} from '../Login/Token.js';

// factored out of components
export async function uiFetch (comp, url, hideAlert = false)  {
  var ss = new SecondServer(comp.props);
  const response = await ss.apiData(url, hideAlert);
  comp.setState({errorMsg: ss.getErrorMsg()});
  return response;
}

export async function uiFetches (comp, url, ss) {
  const response = await ss.apiData(url);
  comp.setState({errorMsg: ss.getErrorMsg()});
  return response;
}

export function stdFilter (search, arrData) {
  var arrCopy = arrData.slice(0);
  if (search.length > 0) {
    const usearch = search.toUpperCase();
    const arrFilter = arrCopy.filter (item => {
      var retcode = false;
      Object.keys(item).forEach(function(key,index) {
        if (typeof(item[key]) === 'string') { 
          retcode |= item[key].toUpperCase().indexOf(usearch) !== -1
        }
      });
      return retcode;
    });
    return arrFilter;
  }
  return arrCopy;
}

export function nestedFilter (search, arrData, arrKeys) {
  if (search.length > 0) {
    const usearch = search.toUpperCase();
    const arrFilter = arrData.filter (item => {
      var retcode = false;
      arrKeys.forEach(function(key) { 
        const t = nestedPropertyOrNull(item, key);
        if (typeof(t) === 'string') { 
          retcode |= t.toUpperCase().indexOf(usearch) !== -1
        }
      });
      return retcode;
    });
    return arrFilter;
  }
  return arrData;
}

export function parseBoolean(str) {
  if (typeof str !== 'string') {
    return Boolean(str)
  }
  const lowerStr = str.toLowerCase();
  if (lowerStr === "true" || lowerStr === "yes" || lowerStr === "1") {
    return true;
  } else if (lowerStr === "false" || lowerStr === "no" || lowerStr === "0") {
    return false;
  } else {
    return Boolean(str); // Default to standard boolean conversion for other strings
  }
}
export function myRBC(props) {
  const strJson = tokenToJson(props.authToken)
  const json = JSON.parse(strJson)
  return json["custom:siteListDb"]
}
export function displayOwner (siteOwner, userList) {
  return siteOwner === userList ? 'You' :
    siteOwner ? 'Others' : 'No one'
}